/**
 * Created by Mark on 06/04/2017.
 */

import React  from 'react';
import DataTableComponent from '../tables/table.component.js';
import StaffService from '../../services/staff-services.js';
import StaffStore from '../../store/staff-store.js'
import { FormattedMessage } from 'react-intl';

export default class TeacherTable extends React.Component {


    constructor(props){
        super();
        this.props = props;
        this.state = {staff:[] , handleDelete:this.props.handleDelete || false , handleEdit:this.props.handleEdit || false , additionalButtons:this.props.additionalButtons || false}
    }

    refresh(){
        StaffService.getAccountsStaff();
    }

    componentDidMount() {
        StaffService.getAccountsStaff();
    }

    componentWillMount(){
        StaffStore.on("CHANGE" , () => {
            this.setState({
                staff:StaffStore.allStaff
            });
        });
    }

    rebuildSchema() {

        let schema = {
            type: 'object',
            properties: {
                uid: {
                    type: 'identification',
                    id: 'uid'
                },
                profileLink: {
                    type: 'string',
                    translationsID: 'ui-14',
                    modifable: true,
                    display: true,
                    defaultMessage: 'Name',
                    editaction:true,
                    id: 'name'
                },
                username: {
                    type: 'string',
                    translationsID: 'ui-22',
                    modifable: true,
                    display: true,
                    defaultMessage: 'Username',
                    id: 'username'
                },
                userTypeText: {
                    type: 'string',
                    translationsID: 'ui-2013',
                    modifable: false,
                    display: true,
                    defaultMessage: 'Typ',
                    id: 'userTypeText'
                },
                classes: {
                    type: 'linkgroup',
                    translationsID: 'ui-320',
                    modifable: false,
                    display: true,
                    defaultMessage: 'Class',
                    className:'hidden-xs',
                    id: 'classesLinks'
                },
            },
            data: this.state.staff
        };

        return schema;
    }

    handelAddUser(){

    }


    render(){
        return <DataTableComponent deleteaction={this.state.handleDelete} editaction={this.state.handleEdit} additionalButtons={this.state.additionalButtons} schema={this.rebuildSchema([])} ref={(object) => { this.table = object; } }  />
    }
}


// WEBPACK FOOTER //
// ./src/components/tables/staff-table.js